<ng-container *transloco="let t">
    <ion-content>
        <div class="profile-modal" [formGroup]="formGroup">
            <ion-grid>
                <ion-row class="avatar-row">
                    <ion-col size="auto">
                        <mp-user-avatar [user]="user" [removable]="false"></mp-user-avatar>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col>
                        <ion-input formControlName="firstName" label="Nombre" labelPlacement="stacked" placeholder="ej: María" ngDefaultControl></ion-input>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col>
                        <ion-input formControlName="lastName" label="Apellidos" labelPlacement="stacked" placeholder="ej: López González" ngDefaultControl></ion-input>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col>
                        <ion-input formControlName="email" type="email" label="Email" labelPlacement="stacked" placeholder="ej: marialopezgonzalez@email.com" ngDefaultControl></ion-input>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col>
                        <ion-button class="save-button" expand="block" (click)="onSave()" [disabled]="formDisabled || formGroup?.invalid">{{ t("general.actions.save") }}</ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
    </ion-content>
</ng-container>
